/**
 * RESPONSIBILITY: draw the mark that says a line is an address.
 *
 * A PATH AND NOT THE PIN EMOJI. An emoji arrives in full colour on Windows and Apple and
 * monochrome everywhere else, sits on a baseline of its own, and cannot be recoloured —
 * so the quietest line on the card would have carried the loudest thing on it. It is
 * also a character typed into a component, and characters a visitor reads come from a
 * field. A path is a mark, like the ones a social row asks for in SocialIcon.
 *
 * Hidden from a screen reader: it says what the address beside it already says, and
 * "pin" announced before every address is noise.
 */
export function PlaceMark() {
  return (
    <svg
      className="place-mark" width="12" height="12" viewBox="0 0 24 24"
      fill="currentColor" aria-hidden="true" focusable="false"
    >
      <path d="M12 2a7 7 0 0 0-7 7c0 5.2 5.4 11.6 6.6 13a.5.5 0 0 0 .8 0C13.6 20.6 19 14.2 19 9a7 7 0 0 0-7-7Zm0 9.6A2.6 2.6 0 1 1 12 6.4a2.6 2.6 0 0 1 0 5.2Z" />
    </svg>
  );
}
